<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />
    <div v-else-if="data.chapter.id" class="mt-8 mb-16">
      <div class="relative py-16 bg-white overflow-hidden">
        <div class="relative px-4 sm:px-6 lg:px-8">
          <div class="text-lg max-w-prose mx-auto">
            <div
              class="block text-base text-center font-semibold tracking-wide uppercase"
            >
              <span class="font-normal">Состояние Главы:</span>
              <span
                :class="[
                  'ml-2',
                  data.chapterstate.id == 5 ? 'text-green-600' : '',
                  data.chapterstate.id == 1 ? 'text-gray-600' : '',
                ]"
                >{{ data.chapterstate.name }}
              </span>
            </div>

            <h1>
              <span
                class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
                >{{ data.chapter.name }}
                <abbr
                  v-if="data.chapter.is_final"
                  title="Эта глава - финальная, будет доступна после завершения всех остальных"
                  class="relative bottom-1 rounded-full ml-2 text-base text-white bg-green-500 hover:bg-green-700 px-2 py-1"
                  >fin</abbr
                >
              </span>
            </h1>

            <h3
              class="mt-8 block text-xl text-center leading-8 font-bold tracking-tight text-gray-900 sm:text-2xl"
            >
              Введение
            </h3>
            <p
              v-html="brFunc(data.chapter.description)"
              class="mt-8 text-xl text-gray-500 leading-8"
            ></p>
            <h3
              class="mt-8 block text-xl text-center leading-8 font-bold tracking-tight text-gray-900 sm:text-2xl"
            >
              Текст
            </h3>
          </div>
          <div
            v-html="data.chapter.text"
            class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto"
          ></div>
          <ErrorMessage v-if="errors.any" :error="errors.any" class="mt-2" />
        </div>
      </div>

      <!-- <h3 class="mb-3 text-center">
        {{ data.chapter.name }}
        <abbr
          v-if="data.chapter.is_final"
          title="Эта глава - финальная, будет доступна после завершения всех остальных"
          class="badge badge-info"
          >fin</abbr
        >
      </h3>
      <p class="mb-5 text-center">
        <strong>Состояние Главы: </strong>
        <span
          v-bind:class="{
            'text-success': data.chapterstate.id == 5,
            'text-muted': data.chapterstate.id == 1,
          }"
          style="font-weight: bold"
          >{{ data.chapterstate.name }}</span
        >
      </p>

      <div class="mb-3"><strong>Введение:</strong></div>
      <p
        class="bg-light p-3 mb-5 bg-white rounded"
        v-html="brFunc(data.chapter.description)"
      ></p>

      <p class="mb-3"><strong>Текст:</strong></p>
      <p
        class="bg-light p-3 mb-5 bg-white rounded"
        v-html="data.chapter.text"
      ></p>
      

      <div class="alert alert-danger" v-if="errors.any">
        {{ errors.any }}
      </div> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import ErrorMessage from "../components/ErrorMessage.vue";
//import jQuery from 'jquery'
export default {
  components: {
    Loader,
    PageTitle,
    BreadCrumbs,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "", validation: "" },
      title: "Просмотр Главы",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/chapters/" + this.$route.params.id + "/show"
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.load = e.response.data.error;
        } else if (e.response.status == 401) {
          this.errors.load = e.response.data.error;
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },
  },
};
</script>